/**
 * Chrome for the public blog. Kept as a named layout so blog routes don't need
 * to change; it is the shared SiteLayout underneath.
 */
import type { ReactNode } from 'react';

import { SiteLayout } from '@/components/SiteLayout';

export const BlogLayout = ({ children }: { children: ReactNode }) => (
  <SiteLayout>{children}</SiteLayout>
);
